import { Button, Card, Col, Row, Upload } from 'antd'
import CustomBreadcrumb from 'src/components/CustomBreadcrumb'
import TableImageConfirm from 'src/components/ImageConfirm/Table'
import DateFilterBlock from 'src/components/FeePartials/DateFilterBlock'

function ImportMailers() {
	return (
		<div>
			<Row style={{ display: 'flex', alignItems: 'center' }}>
				<Col xl={12} lg={12} md={12} sm={24} xs={24}>
					<div style={{ paddingTop: 16 }}>
						<CustomBreadcrumb
							customRoute={[
								{
									breadcrumbName: 'Đơn hàng',
									breadcrumbSubName: 'Đơn hàng',
									path: '/khach-hang/don-hang',
								},
								{
									breadcrumbName: 'Ảnh xác nhận phát',
									breadcrumbSubName: 'Ảnh xác nhận phát',
									path: '/khach-hang/import-don-hang',
								},
							]}
						/>
					</div>
				</Col>
			</Row>

			<div className="site-card-border-less-wrapper" style={{ paddingTop: 20 }}>
				<Card bordered={false}>
					<TableImageConfirm />
				</Card>
			</div>
		</div>
	)
}

export default ImportMailers
